/* tslint:disable:max-line-length */
import gql from 'graphql-tag';

export const DeletePDVS = gql`
  mutation DeletePDVS($ids: [ID!]!) {
    deletePDVS(ids: $ids)
  }
`;
